var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:('background:' + _vm.bgColor)},[_c('Cheader'),_c('back-img'),_c('router-view'),_c('el-backtop'),_c('Cfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }